(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("realms-three", [], factory);
	else if(typeof exports === 'object')
		exports["realms-three"] = factory();
	else
		root["realms-three"] = factory();
})(self, () => {
return 